export default __webpack_public_path__ + "static/media/home.878abc1d.png";